import React, { createContext, useContext, useState } from "react";

const MenuContext = createContext({
  itemsMenus: {},
  setItemsMenus: () => {},
  resetMenus: () => {}
});

export const useMenu = () => useContext(MenuContext);

export const MenuProvider = ({ children }) => {
  const [itemsMenus, setItemsMenus] = useState({});

  const resetMenus = () => {
    setItemsMenus({});
  };

  return (
    <MenuContext.Provider
      value={{
        itemsMenus,
        setItemsMenus,
        resetMenus
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};
